import axios, { AxiosError } from "axios";
const CustomerGroupResource = {
    get(customerGroupId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/customers/groups/${customerGroupId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(request, resultFunc, errorFunc, finallyFunc) {
        axios.post("/admin/v1/customers/groups", request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(customerGroupId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/customers/groups/${customerGroupId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default CustomerGroupResource;
